<template>
    <li class="sponsorship-level-item" :class="{active: selected}" @click="select()">
        <div class="sponsorship-level-card">
            <div class="sponsorship-level-icon">
            </div>
            <div class="sponsorship-level-col">
                <div class="sponsorship-level-header">
                    <div class="sponsorship-level-name">{{ level.name }}</div>
                    <div class="sponsorship-level-price"> {{ level.price }} {{ level.currency }}/{{ $t(`subscriptions.period_${level.paymentPeriod}`) }}</div>
                </div>
                <div class="sponsorship-level-extra" v-if="selected">
                    <slot />
                    <sponsorship-level-info
                    :level="level"
                    />
                </div>
            </div>
        </div>
    </li>
</template>
<script>

import SponsorshipLevelInfo from "@/components/SponsorshipLevelInfo";
import { SponsorshipLevel } from "@/store/models/SponsorshipLevel";

export default {
    name: 'SponsorshipLevelItem',
    components: {
        SponsorshipLevelInfo,
    },
    props: {
        level: {
            type: SponsorshipLevel,
            default: null,
        },
    },
    computed: {
        selected() {
            return this.$store.getters.selectedLevelID === this.level.externalID;
        },
    },
    methods: {
        select() {
            this.$store.dispatch('setSelectedLevelID', this.level.externalID);
        }
    },
};
</script>
<style lang="scss">
.sponsorship-level {
    &-item {
        margin-bottom: 8px;
        position: relative;
        &:last-child{
            margin-bottom: 0px;
        }
    }
    &-item.active &-icon {
        border: 2px solid #161616;
        position: relative;
        &:before{
            content: '';
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            width: 12px;
            height: 12px;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
        }
    }
    &-card {
        display: flex;
        align-items: flex-start;
        border: 2px solid transparent;
        padding: 6px 15px 6px 10px;
        position: relative;
    }
    &-icon {
        cursor: pointer;
        flex-basis: 24px;
        flex-grow: 0;
        flex-shrink: 0;
        height: 24px;
        border: 1px solid;
        border-radius: 50%;
        margin-right: 12px;
        transition: all 0.3s;
        &:hover{
            border: 2px solid #161616;
        }
    }
    &-col {
        width: 100%;
    }
    &-header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        cursor: pointer;
        font-weight: bold;
        font-size: 15px;
        line-height: 22px;
        margin-bottom: 1px;
    }
    &-name {
      width: 60%;
    }
    &-price {
      width: 40%;
      text-align: right;
    }
    &-extra {
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 15px;
        line-height: 22px;
        padding-right: 30px;
    }
}
</style>
